import {
  H1Component,
  H2Component,
  H3Component,
  H4Component,
  H5Component,
  UlList,
  TextBlock,
  TitleDescription,
  OlList,
  NoticeList,
  ListWrapper,
  PersonList,
  TrendTable,
  DayRangeTable,
  RolePlanTable,
} from "components/company/plan/component";
import { WeekBlock } from "../company/plan/component/WeekBlock";
import { TopicDescription } from "../company/plan/TopicDescription";
import {
  ContentBankingList,
  ContentNoticeList,
  ContentOlList,
  ContentPersonList,
  ContentRangeTable,
  ContentTextBlock,
  ContentTrendTable,
  ContentUlList,
} from "../../types";

export const componentMapper = {
  h1: (text: string) => <H1Component text={text} />,
  h2: (text: string) => <H2Component text={text} />,
  h3: (text: string) => <H3Component text={text} />,
  h4: (text: string, icon?: string) => <H4Component text={text} icon={icon} />,
  h5: (text: string) => <H5Component text={text} />,
  "ul-list": ({ title, text, items, icon }: ContentUlList) => (
    <ListWrapper title={title} icon={icon}>
      <UlList items={items} text={text} />
    </ListWrapper>
  ),
  "ol-list": ({ title, text }: ContentOlList) => (
    <ListWrapper title={title}>
      <OlList text={text} />
    </ListWrapper>
  ),
  "notice-list": ({ title, text }: ContentNoticeList) => (
    <ListWrapper title={title}>
      <NoticeList text={text} />
    </ListWrapper>
  ),
  "person-list": ({ title, data }: ContentPersonList) => (
    <ListWrapper title={title}>
      <PersonList data={data} />
    </ListWrapper>
  ),
  "banking-list": ({ title, data }: ContentBankingList) => (
    <ListWrapper title={title}>
      <PersonList data={data} showIcon={false} />
    </ListWrapper>
  ),
  "text-block": ({ title, text, icon, gap }: ContentTextBlock) => (
    <ListWrapper title={title} icon={icon} gap={gap}>
      <TextBlock text={text} />
    </ListWrapper>
  ),

  text: (text: string[]) => <TextBlock text={text} />,
  topicDescription: (description: string) => (
    <TopicDescription text={description} />
  ),
  subTopicDescription: (description: string) => (
    <TitleDescription text={description} />
  ),
  week: (week: string) => <WeekBlock week={week} />,
  "trend-table": ({ rows, title }: ContentTrendTable) => (
    <TrendTable rows={rows} title={title} />
  ),
  "range-table": ({ rows }: ContentRangeTable) => <DayRangeTable rows={rows} />,
  table: ({ rows, columns }: { columns: any; rows: any }) => (
    <RolePlanTable rows={rows} columns={columns} />
  ),
  empty: () => null,
} as const;

export type ComponentMapperKeys = keyof typeof componentMapper;
